import { BookOpen, LineChart } from "lucide-react";
import { images } from "../../assets/images";
import { authTheme } from "../../data/auth/authTheme";
import { loginBranding } from "../../data/auth/loginPage";
import { AssetImage } from "../ui/AssetImage";

const FEATURE_ICONS = {
  resources: BookOpen,
  insights: LineChart,
};

export function LoginBrandingPanel() {
  return (
    <aside
      className="relative hidden min-h-screen overflow-hidden lg:flex lg:w-[44%] lg:max-w-[620px] lg:shrink-0"
      style={{ backgroundColor: authTheme.panelBackground }}
    >
      <div className="relative z-10 flex min-h-screen w-full flex-col px-12 py-14 xl:px-16 xl:py-16">
        <p className="font-inter text-[42px] font-black leading-none tracking-[0.12em] text-white">
          {loginBranding.title}
        </p>

        <div className="mt-16 max-w-[420px]">
          <h1 className="font-inter text-[34px] font-bold leading-[1.15] text-white xl:text-[38px]">
            {loginBranding.heading}
          </h1>
          <p className="mt-5 text-[15px] leading-7 text-white/90">
            {loginBranding.description}
          </p>

          <ul className="mt-12 space-y-10">
            {loginBranding.features.map((feature) => {
              const Icon = FEATURE_ICONS[feature.id] ?? BookOpen;
              return (
                <li key={feature.id} className="flex gap-4">
                  <div className="flex size-12 shrink-0 items-center justify-center rounded-2xl bg-white/20">
                    <Icon className="h-5 w-5 text-white" aria-hidden />
                  </div>
                  <div>
                    <p className="text-[17px] font-semibold text-white">
                      {feature.title}
                    </p>
                    <p className="mt-1.5 text-sm leading-6 text-white/85">
                      {feature.description}
                    </p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div className="pointer-events-none absolute inset-x-0 bottom-0 z-0 h-[38%] min-h-[220px]">
        <div
          className="absolute inset-0 z-10"
          style={{
            background: `linear-gradient(to top, ${authTheme.panelBackground} 8%, rgba(232, 168, 124, 0.72) 42%, rgba(232, 168, 124, 0) 100%)`,
          }}
          aria-hidden
        />
        <AssetImage
          src={images.book}
          alt=""
          aria-hidden
          className="h-full w-full object-cover object-[center_bottom]"
        />
      </div>
    </aside>
  );
}
